export const GOOGLE_FORM_URL ='https://docs.google.com/forms/d/e/1FAIpQLSfg3SkDl0YTSvBkM04pYC03DRCJ0E-g7hpEZJg1uXDiOuFRuA/viewform';
export const WHATSAPP_NUMBER = "919999999999"; // Without '+' and no spaces
export const DEFAULT_PROJECT_NAME = "My Project";


export const CONTACT_FORM_URL ='https://docs.google.com/forms/d/e/1FAIpQLSfCQHkvZtC4rqHVprIV91ByMt8hDzXinJ7fVKmXg_BgegVHSg/viewform?usp=sharing&ouid=105686359881456595590'


